import { Actions } from './detailsActions';
import { Actions as ReclamationsActions } from './reclamationsActions';

/**
 * Etat initiale pour le détail d'une réclamation
 */
const initialState = {
    item: {
        id: 0,
        client: {},
        emetteur: {},
        piece: {},
        observateurs: [],
        countObservateurs: 0,
        adminOuPilote: false,
        statut: 0,
        picto: 0,
        affectationGroupe: null,
        affectationUtilisateur: null,
        isObservateur: false,
        nbActionsSansReponse: 0,
        autoriseCloture: false,
        autoriseAnnulationCloture: false,
    },

    infosDemandeEnlevement: {
        isLoading: false,
        articles: [],
        adresse: {}
    },

    infosLogistique: {},

    qualifications: null,

    infosGenerales: {},

    historique: [],

    infosActionMagasin: {
        isLoading: false
    },

    isLoading: false,
    isObservateursLoading: false,

    isQualificationsLoading: false,
    didQualificationsInvalidate: true,

    isInfosGeneralesLoading: false,
    didInfosGeneralesInvalidate: true,

    isInfosLogistiqueLoading: false,
    didInfosLogistiqueInvalidate: true,

    isInfosSuiviColisLoading: false,

    isHistoriqueLoading: false,
    didHistoriqueInvalidate: true,

    demandesEnlevement: {
        isLoading: false,
        items: []
    }
};

/**
 * Reducer pour le détail d'une réclamation
 */
const reducer = (state = initialState, action) => {

    switch (action.type) {
        // INIT_DETAILS_RECLAMATION
        case Actions.INIT_DETAILS_RECLAMATION:
            return {
                ...initialState
            };

        // Informations de la réclamation
        case Actions.FETCH_RECLAMATION_REQUEST:
            return {
                ...state,
                isLoading: true
            };
        case Actions.FETCH_RECLAMATION_SUCCESS:
            return {
                ...state,
                item: { ...state.item, ...action.reclamation },
                isLoading: false
            };
        case Actions.FETCH_RECLAMATION_FAILURE:
            return {
                ...state,
                error: action.error,
                isLoading: false
            };

        // Informations des observateurs de la réclamation
        case Actions.FETCH_RECLAMATION_OBSERVATEURS_REQUEST:
            return {
                ...state,
                isObservateursLoading: true
            };
        case Actions.FETCH_RECLAMATION_OBSERVATEURS_SUCCESS:
            return {
                ...state,
                item: {
                    ...state.item,
                    observateurs: [...action.observateurs],
                    countObservateurs: action.observateurs.length
                },
                isObservateursLoading: false
            };
        case Actions.FETCH_RECLAMATION_OBSERVATEURS_FAILURE:
            return {
                ...state,
                error: action.error,
                isObservateursLoading: false
            };

        // Ajout d'un observateur
        case Actions.ADD_RECLAMATION_OBSERVATEUR_SUCCESS:
            return {
                ...state,
                item: {
                    ...state.item,
                    isObservateur: true,
                    countObservateurs: state.item.countObservateurs + 1
                }
            };
        case Actions.ADD_RECLAMATION_OBSERVATEUR_FAILURE:
            return {
                ...state,
                error: action.error
            };

        // Suppression d'un observateur
        case Actions.REMOVE_RECLAMATION_OBSERVATEUR_SUCCESS:
            {
                let isUtilisateurCourant = JSON.parse(localStorage.getItem('utilisateur')).id === action.utilisateurId;

                return {
                    ...state,
                    item: {
                        ...state.item,
                        isObservateur: isUtilisateurCourant ? false : state.item.isObservateur,
                        countObservateurs: state.item.countObservateurs - 1,
                        observateurs: state.item.observateurs !== undefined
                            ? state.item.observateurs.filter(x => x.id !== action.utilisateurId)
                            : []
                    }
                };
            }
        case Actions.REMOVE_RECLAMATION_OBSERVATEUR_FAILURE:
            return {
                ...state,
                error: action.error
            };

        // Informations des qualifications de la réclamation
        case Actions.FETCH_RECLAMATION_QUALIFICATIONS_REQUEST:
            return {
                ...state,
                qualifications: null,
                isQualificationsLoading: true,
                didQualificationsInvalidate: false
            };
        case Actions.FETCH_RECLAMATION_QUALIFICATIONS_SUCCESS:
            return {
                ...state,
                qualifications: action.qualifications,
                isQualificationsLoading: false,
                didQualificationsInvalidate: false
            };
        case Actions.FETCH_RECLAMATION_QUALIFICATIONS_FAILURE:
            return {
                ...state,
                error: action.error,
                qualifications: null,
                isQualificationsLoading: false,
                didQualificationsInvalidate: true
            };
        case Actions.INVALIDATE_RECLAMATION_QUALIFICATIONS:
            return {
                ...state,
                didQualificationsInvalidate: true
            };

        // Informations des infos générales de la réclamation
        case Actions.FETCH_RECLAMATION_INFOS_GENERALES_REQUEST:
            return {
                ...state,
                isInfosGeneralesLoading: true,
                didInfosGeneralesInvalidate: false
            };
        case Actions.FETCH_RECLAMATION_INFOS_GENERALES_SUCCESS:
            return {
                ...state,
                infosGenerales: action.infosGenerales,
                isInfosGeneralesLoading: false,
                didInfosGeneralesInvalidate: false
            };
        case Actions.FETCH_RECLAMATION_INFOS_GENERALES_FAILURE:
            return {
                ...state,
                error: action.error,
                isInfosGeneralesLoading: false,
                didInfosGeneralesInvalidate: true
            };
        case Actions.INVALIDATE_RECLAMATION_INFOS_GENERALES:
            return {
                ...state,
                didInfosGeneralesInvalidate: true
            };

        // Informations des infos logistique de la réclamation
        case Actions.FETCH_RECLAMATION_INFOS_LOGISTIQUE_REQUEST:
            return {
                ...state,
                isInfosLogistiqueLoading: true,
                didInfosLogistiqueInvalidate: false
            };
        case Actions.FETCH_RECLAMATION_INFOS_LOGISTIQUE_SUCCESS:
            return {
                ...state,
                infosLogistique: action.infosLogistique,
                isInfosLogistiqueLoading: false,
                didInfosLogistiqueInvalidate: false
            };
        case Actions.FETCH_RECLAMATION_INFOS_LOGISTIQUE_FAILURE:
            return {
                ...state,
                error: action.error,
                isInfosLogistiqueLoading: false,
                didInfosLogistiqueInvalidate: true
            };
        case Actions.INVALIDATE_RECLAMATION_INFOS_LOGISTIQUE:
            return {
                ...state,
                didInfosLogistiqueInvalidate: true
            };

        // Informations de l'historique de la réclamation
        case Actions.FETCH_RECLAMATION_HISTORIQUE_REQUEST:
            return {
                ...state,
                isHistoriqueLoading: true,
                didHistoriqueInvalidate: false
            };
        case Actions.FETCH_RECLAMATION_HISTORIQUE_SUCCESS:
            return {
                ...state,
                historique: action.historique,
                isHistoriqueLoading: false,
                didHistoriqueInvalidate: false
            };
        case Actions.FETCH_RECLAMATION_HISTORIQUE_FAILURE:
            return {
                ...state,
                error: action.error,
                isHistoriqueLoading: false,
                didHistoriqueInvalidate: true
            };
        case Actions.INVALIDATE_RECLAMATION_HISTORIQUE:
            return {
                ...state,
                didHistoriqueInvalidate: true
            };
        // Informations de la réclamation
        case Actions.FETCH_INFOS_DEMANDE_ENLEVEMENT_REQUEST:
            return {
                ...state,
                infosDemandeEnlevement: { ...state.infosDemandeEnlevement, isLoading: true }
            };
        case Actions.FETCH_INFOS_DEMANDE_ENLEVEMENT_SUCCESS:
            return {
                ...state,
                infosDemandeEnlevement: {
                    articles: action.infos.articles ? [...action.infos.articles] : [],
                    adresse: action.infos.adresse,
                    contact: action.infos.contact,
                    transporteurInitial: action.infos.transporteurInitial,
                    isLoading: false
                }
            };
        case Actions.FETCH_INFOS_DEMANDE_ENLEVEMENT_FAILURE:
            return {
                ...state,
                infosDemandeEnlevement: {
                    error: action.error,
                    isLoading: false
                }
            };
        // Informations pour les actions magasins
        case Actions.FETCH_INFOS_ACTION_MAGASIN_REQUEST:
            return {
                ...state,
                infosActionMagasin: {
                    ...state.infosActionMagasin,
                    isLoading: true
                }
            };
        case Actions.FETCH_INFOS_ACTION_MAGASIN_SUCCESS:
            return {
                ...state,
                infosActionMagasin: {
                    ...action.infos,
                    isLoading: false
                }
            };
        case Actions.FETCH_INFOS_ACTION_MAGASIN_FAILURE:
            return {
                ...state,
                infosActionMagasin: {
                    error: action.error,
                    isLoading: false
                }
            };




        // Informations pour les demandes d'enlèvement pour le client d'une réclamation
        case Actions.FETCH_RECLAMATION_DEMANDES_ENLEVEMENT_REQUEST:
            return {
                ...state,
                demandesEnlevement: {
                    items: [],
                    isLoading: true
                }
            };
        case Actions.FETCH_RECLAMATION_DEMANDES_ENLEVEMENT_SUCCESS:
            return {
                ...state,
                demandesEnlevement: {
                    items: [...action.infos.reclamationIds],
                    isLoading: false
                }
            };
        case Actions.FETCH_RECLAMATION_DEMANDES_ENLEVEMENT_FAILURE:
            return {
                ...state,
                demandesEnlevement: {
                    error: action.error,
                    isLoading: false
                }
            };






        case ReclamationsActions.AFFECTATION_SUCCESS:
            {
                if (state.item.id === action.data.reclamation.id) {
                    return {
                        ...state,
                        item: {
                            ...state.item,
                            affectationGroupe: { ...action.data.reclamation.groupe },
                            affectationUtilisateur: { ...action.data.reclamation.utilisateur },
                            adminOuPilote: action.data.adminOuPilote,
                            picto: action.data.picto,
                            isObservateur: action.data.observateur,
                            statut: action.data.reclamation.statut,
                            autoriseCloture: action.data.autoriseCloture,
                            autoriseClotureMessage: action.data.autoriseClotureMessage,
                            autoriseAffectation: action.data.autoriseAffectation,
                            autoriseAnnulationCloture: action.data.autoriseAnnulationCloture
                        }

                    };
                }
                return state;
            }
        case ReclamationsActions.AFFECTATION_WARNING:
            {
                if (state.item.id === action.affectation.reclamation.id) {
                    return {
                        ...state,
                        item: {
                            ...state.item,
                            affectationGroupe: { ...action.affectation.reclamation.groupe },
                            affectationUtilisateur: { ...action.affectation.reclamation.utilisateur },
                            adminOuPilote: action.affectation.adminOuPilote,
                            picto: action.affectation.picto,
                            isObservateur: action.affectation.observateur,
                            statut: action.affectation.reclamation.statut,
                            autoriseCloture: action.affectation.autoriseCloture,
                            autoriseClotureMessage: action.affectation.autoriseClotureMessage,
                            autoriseAffectation: action.affectation.autoriseAffectation,
                            autoriseAnnulationCloture: action.affectation.autoriseAnnulationCloture
                        }

                    };
                }
                return state;
            }
        case ReclamationsActions.CLOTURER_SUCCESS:
            {
                if (state.item.id === action.data.reclamation.id) {
                    return {
                        ...state,
                        item: {
                            ...state.item,
                            statut: action.data.reclamation.statut,
                            affectationGroupe: action.data.reclamation.affectationGroupe, 
                            affectationUtilisateur: action.data.reclamation.affectationUtilisateur,
                            adminOuPilote: action.data.reclamation.adminOuPilote,
                            picto: action.data.reclamation.picto
                        }
                    };
                }
                return state;
            }
        case ReclamationsActions.ANNULER_CLOTURE_SUCCESS:
            {
                if (state.item.id === action.data.reclamation.id) {
                    return {
                        ...state,
                        item: {
                            ...state.item,
                            statut: action.data.reclamation.statut
                        }

                    };
                }
                return state;
            }
        case ReclamationsActions.SET_DATE_VERIFICATION_SUCCESS:
        case ReclamationsActions.ADD_ACTION_SUCCESS:
        case ReclamationsActions.ADD_QUESTION_SUCCESS:
            {
                if (state.item.id === action.data.reclamationId) {
                    return {
                        ...state,
                        item: {
                            ...state.item,
                            dateVerification: action.data.dateVerification,
                            nbActionsSansReponse: action.data.nbActionsSansReponse
                        }

                    };
                }
                return state;
            }
        default:
            return state;
    }
};

export default reducer;